export default __webpack_public_path__ + "static/blob2-b13ca1d15df3aec09b70a1c45edca7d1.svg";